module.exports = __webpack_public_path__ + "img/4.01.thmb.xs.75d3aea8.jpg";